<template> 
        <div :id="id" :height="height" :style="style"></div>
</template>

<script>
    export default {   
        data() {    
            return {         
                chart: ""     
            };  
        },   
        props: {  
            //父组件需要传递的参数：id，width，height，option    
            id: {      
                type: String   
            },    
            width: {      
                type: String,      
                default: "98%"   
            }, 
            height:{
                type:String,    
            },  
            option: {      
                type: Object,         
                default() {        
                    return {    
                        title: {
                        },
                        tooltip: {},
                        xAxis: {
                            data: []
                        },
                        yAxis: {
                            min:'dataMin',
                            max:'dataMax'
                        },
                        series: []        
                    };      
                }    
            }  
        },  
        computed: {    
            style() {   
                return {         
                    height:this.height,
                    width: this.width,   
                };    
            }  
        },
        watch: {    
            //观察option的变化    
            option: {      
                handler(newVal, oldVal) {        
                    if (this.chart) {
                        this.chart.clear()      
                         if (newVal) {            
                             this.chart.setOption(newVal);          
                        } else {            
                            this.chart.setOption(oldVal);          
                        }        
                    } else {            
                        this.init();        
                    }      
                },      
                deep: true //对象内部属性的监听，关键。    
            }  
        },  
        mounted() {     
            this.init();  
        },  
        methods: { 
            init() { 
                this.chart = this.$echarts.init(document.querySelector(`#${this.id}`));  
                this.chart.showLoading();    
                this.chart.clear(); 
                // if(this.id === "worldcloud"){
                //   let maskImage = new Image();
                //  maskImage.src = require("../../assets/imgs/apple.png");
                // //   maskImage.src = require("../../assets/imgs/cloud.png");
                // // maskImage.src = 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI1NnB4IiBoZWlnaHQ9IjI1NnB4IiB2aWV3Qm94PSIwIDAgNTQ4LjE3NiA1NDguMTc2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1NDguMTc2IDU0OC4xNzY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNNTI0LjE4MywyOTcuMDY1Yy0xNS45ODUtMTkuODkzLTM2LjI2NS0zMi42OTEtNjAuODE1LTM4LjM5OWM3LjgxLTExLjk5MywxMS43MDQtMjUuMTI2LDExLjcwNC0zOS4zOTkgICBjMC0yMC4xNzctNy4xMzktMzcuNDAxLTIxLjQwOS01MS42NzhjLTE0LjI3My0xNC4yNzItMzEuNDk4LTIxLjQxMS01MS42NzUtMjEuNDExYy0xOC4yNzEsMC0zNC4wNzEsNS45MDEtNDcuMzksMTcuNzAzICAgYy0xMS4yMjUtMjcuMDI4LTI5LjA3NS00OC45MTctNTMuNTI5LTY1LjY2N2MtMjQuNDYtMTYuNzQ2LTUxLjcyOC0yNS4xMjUtODEuODAyLTI1LjEyNWMtNDAuMzQ5LDAtNzQuODAyLDE0LjI3OS0xMDMuMzUzLDQyLjgzICAgYy0yOC41NTMsMjguNTQ0LTQyLjgyNSw2Mi45OTktNDIuODI1LDEwMy4zNTFjMCwyLjg1NiwwLjE5MSw2Ljk0NSwwLjU3MSwxMi4yNzVjLTIyLjA3OCwxMC4yNzktMzkuODc2LDI1LjgzOC01My4zODksNDYuNjg2ICAgQzYuNzU5LDI5OS4wNjcsMCwzMjIuMDU1LDAsMzQ3LjE4YzAsMzUuMjExLDEyLjUxNyw2NS4zMzMsMzcuNTQ0LDkwLjM1OWMyNS4wMjgsMjUuMDMzLDU1LjE1LDM3LjU0OCw5MC4zNjIsMzcuNTQ4aDMxMC42MzYgICBjMzAuMjU5LDAsNTYuMDk2LTEwLjcxNSw3Ny41MTItMzIuMTIxYzIxLjQxMy0yMS40MTIsMzIuMTIxLTQ3LjI0OSwzMi4xMjEtNzcuNTE1ICAgQzU0OC4xNzIsMzM5Ljc1Nyw1NDAuMTc0LDMxNi45NTIsNTI0LjE4MywyOTcuMDY1eiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=';
                // //   maskImage.src = ''
                  
                //   this.option.series[0].maskImage = maskImage  //自定义图案
                //   let _this = this
                //   maskImage.onload = function(){
                //     _this.chart.setOption(this.option); 
                //   };
                //   console.log(this.option)
                // }else{
                //   this.chart.setOption(this.option);
                // }
                this.chart.hideLoading();
                window.addEventListener("resize", this.chart.resize);    
            }  
        }
    };
</script>
